/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import { useMemo } from 'react';

import { useRobotSelector } from './context';
import { RobotSkin, RobotSkinSample } from './robot.types';

export function getSkinForSample(skinSamples: RobotSkin['samples'], sample: number): RobotSkinSample {
    return {
        ...skinSamples?.default,
        ...skinSamples?.[sample],
    };
}
export function useSkinForSample(skinSamples: RobotSkin['samples'], sample: number): RobotSkinSample {
    return useMemo(() => getSkinForSample(skinSamples, sample), [sample, skinSamples]);
}

export function useCurrentSampleSkin() {
    const sample = useRobotSelector((s) => s.sample);
    const skin = useRobotSelector((s) => s.problem.markup.options.skin);
    return useSkinForSample(skin?.samples, sample);
}
